var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumber2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 119,
    viewBox: "0 0 97 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8665_99)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.082,
    y: 36.4766,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4043 46.2529C61.3477 46.2529 62.9443 46.79 64.1943 47.8643C65.4541 48.9385 66.084 50.3105 66.084 51.9805C66.084 52 66.084 52.0244 66.084 52.0537C66.084 53.04 65.9131 53.9629 65.5713 54.8223C65.2295 55.6719 64.7021 56.5459 63.9893 57.4443C63.2861 58.333 61.9922 59.6416 60.1074 61.3701L57.3535 63.9629V64.168H66.6846V67.9766H51.7139V64.8271L57.0898 59.3926C58.6816 57.7715 59.7217 56.6436 60.21 56.0088C60.6982 55.374 61.0498 54.793 61.2646 54.2656C61.4795 53.7285 61.5869 53.167 61.5869 52.5811C61.5869 51.7412 61.3525 51.1064 60.8838 50.6768C60.4248 50.2471 59.79 50.0322 58.9795 50.0322C57.5049 50.0322 55.8838 50.7646 54.1162 52.2295L51.6553 49.3145C52.7295 48.4062 53.6035 47.7715 54.2773 47.4102C55.7129 46.6387 57.3877 46.2529 59.3018 46.2529C59.3408 46.2529 59.375 46.2529 59.4043 46.2529Z",
    fill: "url(#paint0_linear_8665_99)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8665_99",
    x: 0.000148773,
    y: 0.000138998,
    width: 118.164,
    height: 118.164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.60546
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.5409
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.17464 0 0 0 0 0.335271 0 0 0 0 0.778754 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8665_99"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8665_99",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8665_99",
    x1: 58.0881,
    y1: 79.5206,
    x2: 58.0881,
    y2: 43.9766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#8533EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#00C9B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F06B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber2);
export default __webpack_public_path__ + "static/media/number2.ca241235adde9d24e74c219fc4b48a07.svg";
export { ForwardRef as ReactComponent };